import React, { useState } from 'react';
import { useOnboarding } from '../../contexts/OnboardingContext';
import { Button } from '../ui/button';
import { X } from 'lucide-react';

export const OnboardingBanner: React.FC = () => {
  const { status, shouldShowOnboarding, dismissOnboarding, updateStep } = useOnboarding();
  const [showBanner, setShowBanner] = useState(true);

  if (!shouldShowOnboarding || !showBanner || !status) {
    return null;
  }

  const progress = status.progress || {};
  const completedSteps = [
    progress.hasCreatedClient,
    progress.hasCreatedVendor,
    progress.hasInvitedUser,
  ].filter(Boolean).length;
  const totalSteps = 3;

  const handleContinueSetup = async () => {
    // Reset to welcome step to show the wizard
    await updateStep('welcome');
    // The wizard will be shown by OnboardingWizard component based on shouldShowOnboarding
  };

  return (
    <div className="mb-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <h4 className="text-sm font-semibold text-blue-900 dark:text-blue-100 mb-1">
            Complete Your Setup ({completedSteps}/{totalSteps})
          </h4>
          <p className="text-sm text-blue-800 dark:text-blue-200 mb-3">
            Finish setting up your workspace to unlock all features
          </p>
          <Button
            variant="outline"
            size="sm"
            onClick={handleContinueSetup}
            className="bg-white dark:bg-gray-800"
          >
            Continue Setup
          </Button>
        </div>
        <button
          type="button"
          onClick={() => {
            setShowBanner(false);
            dismissOnboarding();
          }}
          className="ml-4 text-blue-400 hover:text-blue-600 dark:hover:text-blue-300"
        >
          <X className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
};

